import type { MailboxInfo } from "owa-client-types";
import { hasBizChatLicense, hasM365CopilotLicense } from "owa-copilot-settings-utils";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isOcpsPolicyEnabled, OcpsPolicy } from "owa-ocps-policy-store";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { BizChatSidepaneEnablementCodes } from "owa-copilot-settings-store/lib/utils/enablementCodes/BizChatSidepaneEnablementCodes";
import type { CopilotEnablementDiagnostics } from "owa-copilot-settings-store/lib/utils/enablementCodes/CopilotEnablementTypes";

export function isBizchatSidepaneDisabledByPolicy(mailboxInfo: MailboxInfo, diagnostics?: CopilotEnablementDiagnostics): boolean {
    // We only check for tenant policies if user is Non-AI SKU and Not consumer
    const isConsumerUser = isConsumer(undefined, mailboxInfo);
    if (!isGlobalFeatureEnabled("mon-copilot-bizchat-ocps-check-killswitch") &&
        !isUserAiSku(mailboxInfo) &&
        !isConsumerUser) {
        const isCopilotBlockAccessToOpenFilesEnabled = isOcpsPolicyEnabled(OcpsPolicy.CopilotBlockAccessToOpenFiles, 
        /*enabledIfUndefined*/ false // If policy is undefined, we should not enable block access to open files
        );
        
        const isCopilotSidepaneEnabled = isOcpsPolicyEnabled(OcpsPolicy.CopilotChatSidepane, 
        /*enabledIfUndefined*/ true // If policy is undefined, we should enable chat sidepane
        );
        
        if (diagnostics) {
            if (isCopilotBlockAccessToOpenFilesEnabled) {
                diagnostics.code =
                    BizChatSidepaneEnablementCodes.BIZCHAT_SIDEPANE_DISABLED_POLICY_BLOCK_ACCESS_TO_FILES;
            }
            else if (!isCopilotSidepaneEnabled) {
                diagnostics.code =
                    BizChatSidepaneEnablementCodes.BIZCHAT_SIDEPANE_DISABLED_OCPS_POLICY;
            }
        }
        
        return isCopilotBlockAccessToOpenFilesEnabled || !isCopilotSidepaneEnabled;
    }
    return false;
}

function isUserAiSku(mailboxInfo: MailboxInfo): boolean {
    return hasBizChatLicense(mailboxInfo) || hasM365CopilotLicense(mailboxInfo);
}
